module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "viewContainer"
  }, [_c('div', {
    staticClass: "main_container"
  }, [_c('div', {
    staticClass: "fuji"
  }, [_c('div', {
    staticClass: "goodslist1"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "20px",
      "margin-top": "5px"
    }
  }, [_vm._v("搜索/查询")]), _vm._v(" "), _c('span', {
    staticClass: "divReset",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fnReset($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/Reset.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sanjiao",
    staticStyle: {
      "position": "absolute",
      "right": "0",
      "top": "-10px"
    }
  })]), _vm._v(" "), _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "所属城市："
    }
  }, [_c('el-cascader', {
    ref: "cityAll",
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择城市",
      "options": _vm.options,
      "filterable": ""
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.chengshi),
      callback: function($$v) {
        _vm.chengshi = $$v
      },
      expression: "chengshi"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "店铺类型："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "filterable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.shopTypeFun
    },
    model: {
      value: (_vm.shopType),
      callback: function($$v) {
        _vm.shopType = $$v
      },
      expression: "shopType"
    }
  }, _vm._l((_vm.shopTypeArr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [(_vm.shopType != 1) ? _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.shopType == 1) ? _c('el-form', {
    staticClass: "findform"
  }, [_c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "商品分类："
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "flex",
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "visible-change": _vm.choiceShoptype,
      "change": _vm.shopchangeFun
    },
    model: {
      value: (_vm.shopTypeId),
      callback: function($$v) {
        _vm.shopTypeId = $$v
      },
      expression: "shopTypeId"
    }
  }, _vm._l((_vm.shopTypelist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.shopTypeId > 0) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "品牌分类："
    }
  }, [_c('el-select', {
    staticStyle: {
      "display": "flex",
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "visible-change": _vm.choiceBrandtype
    },
    model: {
      value: (_vm.BrandTypeId),
      callback: function($$v) {
        _vm.BrandTypeId = $$v
      },
      expression: "BrandTypeId"
    }
  }, _vm._l((_vm.brandTypelist), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandtypename,
        "value": item.brandtypeid
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.BrandTypeId > 0) ? _c('el-form-item', {
    staticStyle: {
      "display": "flex",
      "width": "30%"
    },
    attrs: {
      "label": "品牌列表："
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    on: {
      "visible-change": _vm.choiceBrand
    },
    model: {
      value: (_vm.BrandId),
      callback: function($$v) {
        _vm.BrandId = $$v
      },
      expression: "BrandId"
    }
  }, _vm._l((_vm.brandListarr), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.brandname,
        "value": item.brandid
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "main_container"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, _vm._l((_vm.inputList), function(item, index) {
    return _c('div', {
      key: 'item-' + item.cluetypeid + '-' + index,
      staticClass: "grid-item"
    }, [_c('label', {
      staticClass: "labelClass",
      attrs: {
        "for": item.cluetypeid
      }
    }, [_vm._v(_vm._s(item.cluetypename))]), _vm._v(" "), _c('el-input', {
      style: ({
        marginLeft: '-2px'
      }),
      attrs: {
        "id": item.cluetypeid,
        "maxlength": "5",
        "onkeyup": "value=value.replace(/[^\\d]/g,'');"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "line-height": "40px",
        "margin-left": "10px"
      }
    }, [_vm._v("元")])], 1)
  }), 0), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iscityadmin == 0 || _vm.scid < 0),
      expression: "iscityadmin == 0 || scid < 0"
    }],
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "10px 0 20px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": function($event) {
        return _vm.addgoodcolunm()
      }
    }
  }, [_vm._v("保存")])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "98%",
      "display": "flex",
      "justify-content": "space-between",
      "text-align": "center",
      "margin": "0 auto"
    }
  }, [_c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4042eca2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/system/PrecisionCustomer.vue
// module id = 1682
// module chunks = 3